module.exports = __webpack_public_path__ + "static/media/sameer_gift_brand_story.3c498dfc.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sameer_gift_brand_story.webp
// module id = 358
// module chunks = 0